import React from "react";
import "../Styles/Home.css";
import Container from "react-bootstrap/Container";
import "bootstrap/dist/css/bootstrap.min.css";
import RmsBeauty from "../Image/B2B-Website-UI/RMS Beauty.png";
import Revive from "../Image/B2B-Website-UI/Revive.png";
import Kevyn from "../Image/B2B-Website-UI/Kevyn Aucoin Cosmetics-2.png";
import Loccitane from "../Image/B2B-Website-UI/frontloccitane.png";

function BeautyBrandsList() {
  return (
    <div>
      <section className="beautyListsBrand">
        <Container>
          <h2 className="BeautyH2Start">
            YOUR NUMBER ONE SOURCE FOR UNIQUE BEAUTY BRANDS
          </h2>
          <div className="row">
            <div className="col-lg-4 col-md-6">
              <div className="BeautyBrandName">
                <img src={RmsBeauty} />
                <h3>RMS Beauty</h3>
                <span>(multi-tasking cream concealer)</span>
                <p>
                  ALLURE Reader's Choice Award Winner 2022 ALLURE Best of Beauty
                  Award Winner 2011 & 2012
                </p>
              </div>
            </div>


            <div className="col-lg-4 col-md-6">
              <div className="BeautyBrandName">
                <img src={Revive} />
                <h3>Revive</h3>
                <span>(Nighttime Exfoliating Moisturizer)</span>
                <p>
                  Net-A-Porter Beauty Hall of Fame WWD Beauty Inc Moisturzier
                  Icons 2023 Marie Claire: Worth It
                </p>
              </div>
            </div>


            <div className="col-lg-4 col-md-6">
              <div className="BeautyBrandName">
                <img src={Kevyn} />
                <h3>Kevyn Aucoin Cosmetics</h3>
                <span>
                  (Sculpting Palette with highlighters, contour powders & blush)
                </span>
              </div>
            </div>

            <div className="col-lg-4 col-md-6">
              <div className="BeautyBrandName">
                <img src={Loccitane} />
                <h3>L'Occitane en Provence</h3>
                <span>(Shea Butter Hand Cream)</span>
                <p>
                  Allure Best of Beauty Award Winner One sold every 3 seconds
                  worldwide Iconic French skincare since 1976
                </p>
              </div>
            </div>
          </div>
        </Container>
      </section>
    </div>
  );
}

export default BeautyBrandsList;
